module.exports = __webpack_public_path__ + "img/horizontal_7_1_7042.74a44aba.png";